import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3mgp73jmn6: FaireBrandEntity = {
  token: "b_3mgp73jmn6",
  type: "brand",
  name: "Arctic Fox & Co. - North America",
  avatarUrl:
    "https://cdn.faire.com/fastly/972979e4a0455078f8f3a96af58039a0afdfc04c489c6d60c03a1e4679944d42.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5a5f9b718358b4d84b95765b5967ed35339aad48a0013743c23cf943aaf31b49.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/972979e4a0455078f8f3a96af58039a0afdfc04c489c6d60c03a1e4679944d42.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5a5f9b718358b4d84b95765b5967ed35339aad48a0013743c23cf943aaf31b49.jpeg",
  location: "Sheridan, WY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 31,
  isInsider: true,
  description:
    "Welcome to our new North American Faire account! We're proud to carry over the success of our UK Faire account, where we're 5.0-star rated and have fulfilled over 2,000 orders.\n\nWe ship from Chicago, IL for fast and low-cost shipping, with no import duties to the US.\n\nBased in Manchester, UK, we are a minimalist and sustainable accessories brand inspired by the Japandi ethos - a blend of Scandinavian and Japanese design, values, and aesthetics.\n\nOur products are made exclusively from recycled, natural, and ethically certified materials. \n\nWhat sets us apart:\n\n-We exclusively use recycled plastic, certified wool, and deadstock fabrics. No virgin plastic is used in production.\n-We only manufacture in internationally accredited factories with ethical production.\n-5% of profits go to WWF to support their work in combating climate change.\n-Each order funds the removal of 1lb of ocean plastic through our partnership with 4ocean.\n-100% of our carbon is offset via the Woodland Trust UK.\n-All of our FW25 range arrives in 100% recyclable paper protective packaging.\n\nFounded in 2017. Simplistic and sustainable - for people and planet. Here to keep you warm.\n\nNo third-party marketplace reselling (Amazon, Etsy, eBay) permitted.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:46.220Z",
    importedBy: "entity-db-cli",
  },
};
